import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ObjectHoliday} from '../object-holiday.model';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {formatNumberToTime} from '../../shared/pipes/time.pipe';
import {LocaleService} from '../../shared/services/locale.service';

/**
 * Компонент для отображения единичного блока из таблицы ObjectHoliday
 */
@Component({
    selector: 'app-object-scheduler-holiday',
    templateUrl: './object-scheduler-holiday.component.html',
    styleUrls: ['./object-scheduler-holiday.component.scss']
    // changeDetection: ChangeDetectionStrategy.OnPush
    ,
    standalone: false
})
export class ObjectSchedulerHolidayComponent implements OnInit {
  @Input() objectHoliday: ObjectHoliday;
  @Input() objectHolidays: ObjectHoliday[];
  @Input() id: number;
  @Input() showCustomTime = false;
  @Input() privilege = true;
  @Output() addObjectHoliday = new EventEmitter();
  @Output() removeObjectHoliday = new EventEmitter();
  public dtStart;
  public dtStop;
  public test = 'abc';
  calendarLocale = null;
  public configForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private localeService: LocaleService) {
    this.calendarLocale = this.localeService.getCalendarLocale();
  }

  ngOnInit() {
    this.createForm();
    this.configForm.valueChanges.subscribe((values) => {
      this.objectHoliday.weekday = parseInt(values.weekday, 10);

      if (this.objectHoliday.type !== values.type) {
        this.objectHoliday.type = values.type;
        if (values.type === 'day') {
          this.configForm.get('workingstop').disable();
          this.configForm.get('workingstart').disable();
          this.configForm.get('weekday').enable();
        } else {
          this.configForm.get('workingstop').enable();
          this.configForm.get('workingstart').enable();
          this.configForm.get('weekday').disable();
        }
      }

    });
  }

  /**
   * Создает форму для заполнения времени и даты
   */
  createForm() {
    const tmpType = this.objectHoliday.type || 'day';
    this.dtStart = new Date();
    this.dtStop = new Date();

    this.dtStart.setHours(8);
    this.dtStart.setMinutes(0);

    this.dtStop.setHours(21);
    this.dtStop.setMinutes(0);

    if (this.objectHoliday.workingstart) {
      const parts = this.objectHoliday.workingstart.split(':');
      this.dtStart.setHours(parseInt(parts[0], 10));
      this.dtStart.setMinutes(parseInt(parts[1], 10));
    }

    if (this.objectHoliday.workingstop) {
      const parts = this.objectHoliday.workingstop.split(':');
      this.dtStop.setHours(parseInt(parts[0], 10));
      this.dtStop.setMinutes(parseInt(parts[1], 10));
    }

    const formModel = {
      date: new Date(this.objectHoliday.date),
      weekday: new FormControl({value: this.objectHoliday.operatingmode.weekday === undefined ? 1 : this.objectHoliday.operatingmode.weekday, disabled: tmpType !== 'day'}),
      type: tmpType,
      workingstart: new FormControl({value: this.objectHoliday.workingstart || '', disabled: tmpType !== 'time'}),
      workingstop: new FormControl({value: this.objectHoliday.workingstop || '', disabled: tmpType !== 'time'})
    };

    this.configForm = this.formBuilder.group(formModel as { [p: string]: any });
  }

  /**
   * Обработка изменений начальной и конечной даты
   */
  public setObjectHolidayTime() {
    this.objectHoliday.workingstart = formatNumberToTime(this.dtStart.getHours() * 60 + this.dtStart.getMinutes());
    this.objectHoliday.workingstop = formatNumberToTime(this.dtStop.getHours() * 60 + this.dtStop.getMinutes());
  }

  public clearTime(handler) {
    this.objectHoliday[handler] = '';
  }
  public fromDateChanged(event) {
    if (event && event instanceof Date) {
      this.objectHoliday.date = event.getTime();
    }
  }

  public excludeFilter = (d: Date): boolean => {
    const year = d.getFullYear();
    const month = d.getMonth();
    const date = d.getDate();

    if (this.objectHolidays && this.objectHolidays.filter(holiday =>
      new Date(holiday.date).getFullYear() === year
      && new Date(holiday.date).getMonth() === month
      && new Date(holiday.date).getDate() === date).length === 1) {
      return false;
    }
    return true;
  };

}
